<template>
    <div
        :class="
            'd-flex flex-row justify-between align-center chapter-content px-3 pb-3 pt-2 mb-2 chapter-text ' +
            typeClass.className
        "
    >
        <div class="d-flex flex-column col-11 flex-fill justify-start align-start" @click="setPage" :data-cy="`HighlightItem-${value}-serialized-container`">
            <d-flex class="row mx-0 mb-1 flex-nowrap">
                <div class="col-auto pa-0 mr-1">
                    <span class="label label-primary">{{  typeClass.type }}</span>
                </div>
                <div class="col-auto pa-0">
                    <span class="label label-secondary">{{ info }}</span>
                </div>
            </d-flex>
            <span class="d-inline-block text-truncate" style="max-width: 90%">
                {{ marker_data.serialized }}
            </span>
        </div>
        <div class="col-1 pa-0 text-right">
            <v-btn :data-cy="`HighlightItem-${value}-delete-button`" icon small color="primary" :loading="loading" dark @click="deleteHighlight">
                <!-- <v-icon dark class="">mdi-delete</v-icon> -->
                <v-img :src="trashIcon" width="32"></v-img>
            </v-btn>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

import HighlightService from '@/services/highlight'

export default {
    props: {
        marker_data: { type: Object, default: null },
        value: Number
    },
    data() {
        return {
            loading: false,
            trashIcon: require('@/assets/img/icons/new-reading/highlight/icon-trash.svg')
        }
    },
    computed: {
        ...mapState({
            currentStage: (state) => state.bookReading.currentStage,
            currentPage: (state) => state.bookReading.currentPage,
            currentChapter: (state) => state.bookReading.currentChapter,
            currentChapterData: (state) => state.bookReading.currentChapterData,
            bookHighlightData: (state) => state.bookReading.bookHighlightData,
        }),
        info() {
            return `${this.$t('bookReading.chapter')} ${
                this.marker_data.chapter.chapterNumber
            } - ${this.$t('bookReading.page')} ${this.marker_data.page}`
        },
        typeClass() {
            switch (this.marker_data.ordinalHighlightType) {
                case 0:
                    return { className: 'bg-characters', type: 'Personajes' }
                case 1:
                    return { className: 'bg-actions', type: 'Acciones' }
                case 2:
                    return { className: 'bg-vocabulary', type: 'Vocabulario' }
                case 3:
                    return { className: 'bg-places', type: 'Lugares' }
                default:
                    return ''
            }
        },
    },
    methods: {
        ...mapActions('bookReading', [
            'setCurrentPage',
            'setCurrentChapter',
            'setCurrentChapterData',
            'hideAllUtils',
            'spliceHighlight',
            'setHighlightData',
        ]),
        setPage() {
            window.scrollTo(0, 0)
            let bookPage = document.querySelector(`#bookpage_${this.currentPage}`)
            if (bookPage) bookPage.style.display = 'none'

            let chapterHtml = document.querySelector(`#chapter_${this.currentChapter}`)
            if (chapterHtml) chapterHtml.style.display = 'none'

            this.setCurrentChapter(this.marker_data.chapter.chapterNumber)
            this.setCurrentPage(this.marker_data.page)

            chapterHtml = document.querySelector(`#chapter_${this.currentChapter}`)
            if (chapterHtml) chapterHtml.style.display = 'block'

            const currentPage = document.querySelector(`.current-page`)
            if(currentPage) currentPage.classList.toggle('current-page')

            bookPage = document.querySelector(`#bookpage_${this.currentPage}`)
            if (bookPage) {
                bookPage.style.display = 'flex'
                bookPage.classList.toggle('current-page')
            }

            this.setCurrentChapterData(this.marker_data.chapter)
            this.hideAllUtils()
        },
        deleteHighlight() {
            const tokenSplitter = "\n";
            setTimeout(() => {
                this.loading = !this.loading
            }, 500)
            this.$highlight.delete(
                this.marker_data.id,
                `#bookpage_${this.currentPage}`,
                this.setHighlighType(this.marker_data.ordinalHighlightType),
                this.marker_data.serialized.split(tokenSplitter)
            )
            this.spliceHighlight(this.marker_data)
            HighlightService.delete(this.marker_data.id)
                .then((response) => {
                    this.setHighlightData(response.content.highlight)
                })
                .catch((error) => console.error(error))
            this.hideAllUtils()
            this.loading = !this.loading
        },
        setHighlighType(type) {
            switch (type) {
                case 0:
                    return 'characters'
                case 1:
                    return 'actions'
                case 2:
                    return 'vocabulary'
                case 3:
                    return 'places'
                default:
                    return ''
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.chapter-content {
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)) !important;
    transition: background-image 0.5s ease;
}
.chapter-content:hover {
    cursor: pointer;
    background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)) !important;
}
.chapter-text {
    // border: 1.5px solid #514773 !important;
    background: white;
    color: #64748B;
    .label{
        border-radius: 2px;
        color: white;
        font-size: 10px;
        font-weight: 600;
        padding: 2px 4px;
        text-transform: uppercase;
    }
}

.chapter-active {
    border: 1.5px solid #514773 !important;
    background: #514773 !important;
    color: white !important;
}

.bg-vocabulary {
    background: #FBF5E4;
    .label-primary{
        background: #EFCE6D;
    }
    .label-secondary{
        background: #F4DFA0;
    }
}
.bg-characters {
    background: #E3FCEB;
    .label-primary{
        background: #3FB16D;
    }
    .label-secondary{
        background: #7ED7A0;
    }
}
.bg-actions {
    background: #E3F2FC;
    .label-primary{
        background: #33B2F5;
    }
    .label-secondary{
        background: #90D3FE;
    }
}
.bg-places {
    background: #FEDFEF;
    .label-primary{
        background: #E179B8;
    }
    .label-secondary{
        background: #F6BCDE;
    }
}
</style>
